import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://stepmother-friends-manga.com${item.href}`, name: item.label }
      : { '@id': 'https://stepmother-friends-manga.com', name: item.label },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <span className="text-foreground-400 mx-1">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                )}
                {isLast ? (
                  <span className="breadcrumb-current">{item.label}</span>
                ) : (
                  <Link
                    to={item.href || '/'}
                    className="breadcrumb-link cursor-pointer"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string) {
  const cat = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || slug },
  ];
}

export function getArticleBreadcrumb(article: { title: string; category: string }) {
  const cat = categories.find((c) => c.slug === article.category);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || article.category, href: `/category/${article.category}` },
    { label: article.title },
  ];
}